import React from 'react';
import {View, Platform} from 'react-native';

import Screen from '../../shared/components/screen';

import {ServicesContent} from '../../shared/components/content';
import {useDeviceSize, DeviceSize} from '../../shared/theme/helpers';
import {Text} from '../../shared/components/text';
import {CustomScrollView} from '../../shared/components/scrollView';
import {useStyles} from '../../shared/hooks/styles';

export default () => {
  const styles = useStyles(({theme, isDesktop}) => ({
    contentContainer: {
      flex: 1,
    },
    sectionContainer: {
      flex: 1,
      marginTop: Platform.select({android: 30, ios: 30, web: 30}),
      paddingHorizontal: 24,
      paddingBottom: theme.screen.bottomOffset - (isDesktop ? 40 : 20),
    },
    sectionTitle: {...theme.fonts.h2, marginBottom: 30},
  }));
  const size = useDeviceSize();

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          {size === DeviceSize.desktop ? (
            <Text style={styles.sectionTitle} testID='screen-header-title'>
              Доступные возможности
            </Text>
          ) : null}
          <ServicesContent useBackgroundPattern />
        </View>
      </CustomScrollView>
    </Screen>
  );
};
